import script from "./AnimauxDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimauxDetails.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/animauxdetails.css?vue&type=style&index=0&id=12ac1621&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ac1621"]])

export default __exports__